import type { PluginExports } from 'graylog-web-plugin/plugin';

import EventProcedureForm from './EventProcedureForm';
import EventProcedureSummary from './EventProcedureSummary';

const eventProceduresBindings: PluginExports = {
  'views.components.eventProcedureForm': [
    {
      component: EventProcedureForm,
      key: 'eventProcedureForm',
    },
  ],
  'views.components.eventProcedureSummary': [
    {
      component: EventProcedureSummary,
      key: 'eventProcedureSummary',
    },
  ],
};

export default eventProceduresBindings;
